{
  "hero.title": "Conmutador de Entornos Multi-CLI",
  "hero.tagline-1": "entra en un estado de flujo zen para programar.",
  "hero.tagline-2": "cambio de entorno fluido.",
  "hero.subtitle": "Gestión unificada de configuraciones de Claude Code, Codex y OpenCode con conmutación automática de proxy API",
  "hero.getDocs": "Documentación",
  "features.title": "Características",
  "features.multiCli.title": "Soporte Multi-CLI",
  "features.multiCli.desc": "Soporte para Claude Code, Codex y OpenCode con configuración por proyecto",
  "features.multiConfig.title": "Gestión de Configuración",
  "features.multiConfig.desc": "Gestiona todas las configuraciones de proveedores API en un archivo JSON unificado",
  "features.daemon.title": "Daemon Unificado",
  "features.daemon.desc": "Un único proceso zend aloja tanto el servidor proxy como la interfaz web",
  "features.failover.title": "Conmutación de Proxy",
  "features.failover.desc": "Proxy HTTP integrado con conmutación automática cuando el proveedor principal no está disponible",
  "features.routing.title": "Enrutamiento por Escenario",
  "features.routing.desc": "Enrutamiento inteligente basado en características de la solicitud (pensamiento, imagen, etc.)",
  "features.binding.title": "Vinculaciones de Proyecto",
  "features.binding.desc": "Vincula directorios a perfiles y CLIs específicos para configuración automática a nivel de proyecto",
  "features.envVars.title": "Variables de Entorno",
  "features.envVars.desc": "Configura variables de entorno por CLI a nivel de proveedor",
  "features.webUi.title": "Interfaz Web",
  "features.webUi.desc": "Gestión visual en navegador con acceso protegido por contraseña",
  "features.webSecurity.title": "Seguridad Web",
  "features.webSecurity.desc": "Contraseña autogenerada, autenticación por sesiones, cifrado RSA para transporte de tokens",
  "features.configSync.title": "Sincronización de Config",
  "features.configSync.desc": "Sincroniza proveedores, perfiles y ajustes entre dispositivos con cifrado AES-256-GCM",
  "features.comingSoon": "Más funciones por venir, ¡estén atentos!",
  "install.title": "Inicio Rápido",
  "install.step1.title": "Instalar GoZen",
  "install.step1.desc": "Script de instalación en una línea",
  "install.step2.title": "Configurar Proveedor",
  "install.step2.desc": "Añadir el primer proveedor de API",
  "install.step3.title": "Iniciar",
  "install.step3.desc": "Iniciar CLI con la configuración predeterminada",
  "commands.title": "Comandos",
  "commands.command": "Comando",
  "commands.description": "Descripción",
  "commands.items.start": "Iniciar CLI (usa vinculación de proyecto o config predeterminada)",
  "commands.items.profile": "Iniciar con el perfil especificado",
  "commands.items.profilePick": "Seleccionar perfil de forma interactiva",
  "commands.items.cli": "Usar CLI especificado (claude/codex/opencode)",
  "commands.items.yes": "Aprobar automáticamente permisos CLI (claude --permission-mode acceptEdits, codex -a never)",
  "commands.items.use": "Usar proveedor especificado directamente (sin proxy)",
  "commands.items.pick": "Seleccionar proveedor de forma interactiva para iniciar",
  "commands.items.list": "Listar todos los proveedores y perfiles",
  "commands.items.configAddProvider": "Añadir un nuevo proveedor",
  "commands.items.configAddProfile": "Añadir un nuevo perfil",
  "commands.items.configDefaultClient": "Establecer el cliente CLI predeterminado",
  "commands.items.configDefaultProfile": "Establecer el perfil predeterminado",
  "commands.items.configResetPassword": "Restablecer la contraseña de acceso a la interfaz web",
  "commands.items.configSync": "Extraer configuración del backend de sincronización remota",
  "commands.items.daemonStart": "Iniciar el daemon zend",
  "commands.items.daemonStop": "Detener el daemon",
  "commands.items.daemonStatus": "Mostrar estado del daemon",
  "commands.items.daemonEnable": "Instalar el daemon como servicio del sistema",
  "commands.items.daemonDisable": "Desinstalar el servicio del sistema",
  "commands.items.bind": "Vincular directorio actual a un perfil",
  "commands.items.bindCli": "Vincular directorio actual a un CLI especificado",
  "commands.items.unbind": "Desvincular directorio actual",
  "commands.items.status": "Mostrar estado de vinculación del directorio actual",
  "commands.items.web": "Abrir Web UI en el navegador (inicia daemon automáticamente)",
  "commands.items.upgrade": "Actualizar a la última versión",
  "commands.items.version": "Mostrar versión",
  "commands.items.completion": "Generar script de completado de shell (zsh/bash/fish)",
  "homepage.title": "Conmutador de Entornos Multi-CLI"
}
